document.addEventListener("DOMContentLoaded", (event) => {
  const allCustomMenuItems = document.querySelectorAll(
    ".custom-mega-menu-hover-layout-wrapper-left-item"
  );
  console.log(allCustomMenuItems);
  const allCustomSubmenus = document.querySelectorAll(
    ".custom-mega-menu-hover-layout-wrapper-center"
  );
  const customProductDetails = document.getElementById(
    "custom-product-details"
  );
  const customNavigationContainer = document.querySelector(
    ".custom-mega-menu-hover-layout-wrapper"
  );
  const allProductItems = document.querySelectorAll(".custom-mega-menu-hover-layout-wrapper-right-item");

  // Function to show specific product
  function showProduct(productKey) {
    // Hide all products
    allProductItems.forEach((item) => item.classList.remove("custom-active"));

    // Show specific product
    const targetProduct = document.getElementById(
      `custom-product-${productKey}`
    );
    if (targetProduct) {
      targetProduct.classList.add("custom-active");
      customProductDetails.classList.add("custom-show");
    }
  }

  // Function to show specific submenu
  function showSubmenu(submenuKey) {
    // Hide all submenus
    // Show specific submenu
    const targetSubmenu = document.getElementById(
      `custom-submenu-${submenuKey}`
    );
    if (targetSubmenu) {
      setTimeout(() => {
        allCustomSubmenus.forEach((submenu) =>
          submenu.classList.remove("custom-show")
        );
        targetSubmenu.classList.add("custom-show");
        console.log(targetSubmenu,"targetSubmenutargetSubmenutargetSubmenu added");
        if(targetSubmenu.querySelector(`.custom-center-menu-hover-items`)){
          setTimeout(() => {
            OverlayScrollbarsGlobal.OverlayScrollbars({ target: targetSubmenu.querySelector(`.custom-center-menu-hover-items`) }, {
              overflow: {
                x: 'hidden',  // Disable horizontal scroll
                y: 'scroll'   // Enable vertical scroll
              },
              scrollbars: {
                visibility: 'auto',
                autoHide: 'never',
              },
              paddingAbsolute: true // Automatically adds padding for scrollbar
              
            });
          },100);
        }
        
      },100);
      
    }
  }

  // Handle ALL menu item hover
  allCustomMenuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      // Remove active class from all menu items
      allCustomMenuItems.forEach((mi) => mi.classList.remove("custom-active"));
      // Add active class to current item
      item.classList.add("custom-active");
      // Hide all submenus and product details when hovering items without submenus
      allCustomSubmenus.forEach((submenu) =>
        submenu.classList.remove("custom-show")
      );
      customProductDetails.classList.remove("custom-show");
      allProductItems.forEach((pi) => pi.classList.remove("custom-active"));
      // If this item has a submenu, show it, otherwise hide all
      if (item.hasAttribute("data-submenu")) {
        const submenuKey = item.getAttribute("data-submenu");
        showSubmenu(submenuKey);
      }
      
    });
  });

  // Handle submenu item hover for ALL submenus
  allCustomSubmenus.forEach((submenu) => {
    const submenuItems = submenu.querySelectorAll(
      ".custom-mega-menu-hover-layout-wrapper-center-item"
    );

    submenuItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        // Remove active class from all submenu items in ALL submenus
        document
          .querySelectorAll(
            ".custom-mega-menu-hover-layout-wrapper-center-item"
          )
          .forEach((si) => si.classList.remove("custom-active"));
        // Add active class to current item
        item.classList.add("custom-active");

        // Show product details if this item has data-product attribute
        if (item.hasAttribute("data-product")) {
          const productKey = item.getAttribute("data-product");
          showProduct(productKey);
        } else {
          customProductDetails.classList.remove("custom-show");
          allProductItems.forEach((pi) => pi.classList.remove("custom-active"));
        }
      });
    });
  });

  // Hide menus when mouse leaves the navigation container
  customNavigationContainer.addEventListener("mouseleave", () => {
    // Remove all active classes
    allCustomMenuItems.forEach((item) =>
      item.classList.remove("custom-active")
    );
    document
      .querySelectorAll(".custom-mega-menu-hover-layout-wrapper-center-item")
      .forEach((item) => item.classList.remove("custom-active"));
    allProductItems.forEach((item) => item.classList.remove("custom-active"));

    // Hide all submenus and product details
    /*allCustomSubmenus.forEach((submenu) =>
      submenu.classList.remove("custom-show")
    );*/
    customProductDetails.classList.remove("custom-show");
  });

  // Keep submenu visible when hovering over any submenu
  allCustomSubmenus.forEach((submenu) => {
    submenu.addEventListener("mouseenter", () => {
      // Keep the corresponding menu item active
      const submenuId = submenu.id;
      const submenuKey = submenuId.replace("custom-submenu-", "");
      const correspondingMenuItem = document.querySelector(
        `[data-submenu="${submenuKey}"]`
      );
      if (correspondingMenuItem) {
        correspondingMenuItem.classList.add("custom-active");
      }
      submenu.classList.add("custom-show");
    });
  });

  if (customProductDetails) {
    // Keep product details visible when hovering over it
    customProductDetails.addEventListener("mouseenter", () => {
      // Keep the chain active
      const activeProductItem = document.querySelector(
        ".custom-product-item.custom-active"
      );
      if (activeProductItem) {
        const productId = activeProductItem.id;
        const productKey = productId.replace("custom-product-", "");

        // Find and activate the corresponding submenu item
        const correspondingSubmenuItem = document.querySelector(
          `[data-product="${productKey}"]`
        );
        if (correspondingSubmenuItem) {
          correspondingSubmenuItem.classList.add("custom-active");

          // Find and activate the parent submenu
          const parentSubmenu = correspondingSubmenuItem.closest(
            ".custom-mega-menu-hover-layout-wrapper-center"
          );
          if (parentSubmenu) {
            parentSubmenu.classList.add("custom-show");

            // Find and activate the corresponding menu item
            const submenuId = parentSubmenu.id;
            const submenuKey = submenuId.replace("custom-submenu-", "");
            const correspondingMenuItem = document.querySelector(
              `[data-submenu="${submenuKey}"]`
            );
            if (correspondingMenuItem) {
              correspondingMenuItem.classList.add("custom-active");
            }
          }
        }
      }

      customProductDetails.classList.add("custom-show");
    });
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(`.icons_megamenu--item a[href="#open-chat"]`).forEach((el)=>{
    el.addEventListener("click",(evt) => {
      evt.preventDefault();
      open_chat_custom();
    });
  });
  document.querySelectorAll(".cursor-pointer-link").forEach((el) => {
    el.addEventListener("click",(evt) => {
      window.location.href = el.dataset.href;
    });
  });
  document.querySelectorAll('div[data-overlayscrollbars-initialize]').forEach(element => {
    OverlayScrollbarsGlobal.OverlayScrollbars({ target: element }, {
      overflow: {
        x: 'hidden',  // Disable horizontal scroll
        y: 'scroll'   // Enable vertical scroll
      },
      scrollbars: {
        visibility: 'auto',
        autoHide: 'never',
      },
      paddingAbsolute: true // Automatically adds padding for scrollbar
      
    });
  });
  document.querySelectorAll('div[data-overlayscrollbars-initialize-2]').forEach(element => {
    OverlayScrollbarsGlobal.OverlayScrollbars({ target: element }, {
      overflow: {
        x: 'scroll',  // Disable horizontal scroll
        y: 'hidden'   // Enable vertical scroll
      },
      scrollbars: {
        visibility: 'auto',
        autoHide: 'never',
      },
      paddingAbsolute: true // Automatically adds padding for scrollbar
      
    });
  });
  const hovermenufirst = document.querySelector(".custom-mega-menu-hover-layout-wrapper-left-item");
  if(hovermenufirst){
    hovermenufirst.classList.add("custom-active");
    const secondMenuMain = document.querySelector(`#custom-submenu-${hovermenufirst.dataset.submenu}`);
    if(secondMenuMain){
      secondMenuMain.classList.add("custom-show");
      const secondMenuFirst = secondMenuMain.querySelector(".custom-mega-menu-hover-layout-wrapper-center-item");
      if(secondMenuFirst){
        secondMenuFirst.classList.add("custom-active");
        const rightSide = document.querySelector(".custom-mega-menu-hover-layout-wrapper-right");
        if(rightSide){
          rightSide.classList.add("custom-show");
          rightSide.querySelector(`#custom-product-${secondMenuFirst.dataset.product}`).classList.add("custom-active");
        }
        
      }
      
    }
    
  }
   
  const menuDrawer = document.querySelector('#Details-menu-drawer-container');
    
  if (menuDrawer) {
    const drawer = menuDrawer.querySelector('.menu-drawer');
    
    menuDrawer.querySelector('.header__icon').addEventListener('click', function(e) {
      // Only close if clicking the summary/toggle button, not child elements
      if (menuDrawer.hasAttribute('open') && e.target.closest('summary')) {
        e.preventDefault();
        
        // Trigger closing animation
        drawer.style.transform = 'translateX(-100%)';
        
        setTimeout(() => {
          menuDrawer.removeAttribute('open');
          drawer.style.transform = '';
        }, 680);
      }
    });
  }
});